
<template>
  <v-list-item v-if="playlist !== null">
    <v-list-item-icon v-if="$slots.button">
      <slot name="button" />
    </v-list-item-icon>
    <v-list-item-avatar class="mr-4">
      <img :src="playlist.images[0].url" />
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title v-html="playlist.name"></v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import cms from '../../cms'

@Component
export default class BuilderPlaylistTile extends Vue {
  @Prop() value!: string

  playlist: {
    images: { url: string }[]
    name: string
  } | null = null

  created () {
    this.watchQuery(this.value)
  }

  @Watch('value')
  async watchQuery (value: string) {
    if (this.value === '') {
      this.$emit('input', '')
      return
    }

    try {
      const playlist = await cms.api.spotify.getPlaylist(value)

      if (playlist) {
        this.playlist = playlist

        this.$emit('input', this.value)
      }
    } catch (e) {
      alert('Playlist not found')
    }
  }
}
</script>

<style scoped></style>
